import { render, staticRenderFns } from "./JCommComments.vue?vue&type=template&id=38b78ced&"
import script from "./JCommComments.vue?vue&type=script&lang=js&"
export * from "./JCommComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports